import React, { Component, useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect, useDispatch, useSelector } from "react-redux"
import { RouteComponentProps, useLocation, withRouter } from "react-router-dom"
import { Container, Label } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import BasicTable from "../../../components/BasicTable/BasicTable"
// import WardrobesTablesColumns from "./WardrobesTableColumns"
import AnalyticsTableColumns from "./AnalyticsTableColumns"
import './Analytics.scss'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { 
  requestConfirmation,
  getFeedAnalytics,
  changeFeedAnalyticsQueryObject,
  openAlert
} from "../../../store/actions"
import moment from "moment-timezone"

interface Props extends RouteComponentProps{
  t: (name: string) => string;  
  feedAnalytics: any[];
  onDelete: any;
  totalItems: number;
  perPage: number;
  page: number;
  isLoading: boolean;
}

const Analytics:React.FC<Props> = ({t, feedAnalytics, onDelete, totalItems, perPage, page, history, location, isLoading }) => {
  const dispatch = useDispatch();
  // const QUERY_OBJECT_INIT = { sort: 'created_at', direction: 'desc' };
  // const [queryObject, setQueryObject] = useState(QUERY_OBJECT_INIT);
  const QUERY_OBJECT_INIT = useSelector((state: any) => state.FeedAnalytics.initialQueryObject)
  const queryObject = useSelector((state: any) => state.FeedAnalytics.queryObject)
  const setQueryObject = (queryObject: any) => dispatch(changeFeedAnalyticsQueryObject(queryObject))

  const [date, setDate] = useState<Date | undefined>(undefined)

  const onOpenAlert = (status: string, text: string) => {
		dispatch(openAlert({ text, status }))
	}

  useEffect(() => {
    const params = new URLSearchParams(location?.search)
    const sort = params.get("sort")
    const direction = params.get("direction")
    const period_from = params.get("period_from")
    const period_to = params.get("period_to")
    if(sort && direction && !(period_from && period_to)){
      // setQueryObject({ ...queryObject, sort, direction })
      handleSetQueryObject({ ...queryObject, sort, direction }, true)
    }if(sort && direction && (period_from && period_to)){
      setQueryObject({ ...queryObject, sort, direction })
      setTimeout(() => {
        setDateRange([new Date(period_from), new Date(period_to)])
      }, 200)
    }
  }, [])

  // const triggerPageQueryString = () => {
  //   //fix no pagination bug on first enter
  //   //it forces state change at BasicTable pagination
  //   history.replace(`${location.pathname}?page=`);
  //   page && setTimeout(() => {
  //     history.replace(`${location.pathname}?page=${page}`);
  //   }, 50)
  // }

  const handleSetQueryObject = (value: any, forceReload?: boolean) => {
    if((JSON.stringify(queryObject) !== JSON.stringify(value)) || forceReload){
      dispatch(getFeedAnalytics({ page: 1, queryObject: value }))
    }
    setQueryObject(value)
  }

  // const handleBanItem = (nanoId: string, isBanned: boolean) => {
  //   dispatch(requestConfirmation(
  //     `Do  you want to ${!isBanned ? 'ban' : 'unban'} this item?`,
  //     (data: any) => banItem(nanoId, isBanned, data),
  //     undefined,
  //     !isBanned ? 'Yes, Ban!' : 'Yes, Unban!',
  //     undefined,
  //     !isBanned,
  //     !isBanned
  //   ));
  // }

  // const banItem = async (nanoId: string, isBanned: boolean, data:any) => {
  //   try {
  //     let response: any = {};
  //     if(!isBanned){
  //       response = await ban('items', nanoId, {
  //         "comment" : data?.comment,
  //         "expired_at": data?.date
  //       })
  //     } else {
  //       response = await unban('items', nanoId)
  //     }
      
  //     if(response?.status === "success"){
  //       dispatch(getWardrobes({ page, queryObject }))
  //       triggerPageQueryString()
  //     }
  //   } catch (e) {
  //       console.log(e)
  //   }
  // }

  // const triggerShowFeedItems = () => {
  //   handleSetQueryObject({
  //     ...queryObject,
  //     show_feeder_items: queryObject.show_feeder_items ? 0 : 1
  //   }, true)
  // }

  const [dateRange, setDateRange] = useState<any>([null, null]);
  const [startDate, endDate] = dateRange;
  const [allowClear, setAllowClear] = useState(false);
  const [shouldCloseOnSelect, setShouldCloseOnSelect] = useState(false);

  const handleChangeDatepicker = (date: Date) => {
    const yesterday = moment().subtract(1, 'days');
    if(moment(date) > yesterday) {
      return onOpenAlert("danger", `Pick a date before ${yesterday.format("YYYY-MM-DD")}`)
    }
    handleSetQueryObject({...queryObject, period: date ? moment(date).format("YYYY-MM-DD"): "", type: "daily"})
  }

  useEffect(() => {
    if(startDate && endDate){
      const customFilters = {
        ...queryObject,
        period_from: moment(startDate).format('YYYY-MM-DD'),
        period_to: moment(endDate).format('YYYY-MM-DD')
      }
      customFilters.sort = customFilters.sort?.replace("totals", "period_counts")

      handleSetQueryObject(customFilters)
      setAllowClear(true)

    }else if(allowClear && startDate === null && endDate === null){
      const customFilters = { ...queryObject }
      delete customFilters.period_from
      delete customFilters.period_to
      customFilters.sort = customFilters.sort?.replace("period_counts", "totals")
      handleSetQueryObject(customFilters)
    }
  }, [startDate, endDate])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Ads Manager" breadcrumbItem={`Feed Items`} totalItems={totalItems} />

          <BasicTable
            items={feedAnalytics}
            columns={AnalyticsTableColumns(
              (page - 1) * perPage,
              t,
              queryObject,
              handleSetQueryObject,
              QUERY_OBJECT_INIT,
              queryObject?.period_from && queryObject?.period_to
            )}
            searchbar={false}
            getAction={({ page }: any) => getFeedAnalytics({ page, queryObject })}
            totalSize={totalItems}
            sizePerPage={perPage}
            defaultSort={queryObject}
            //@ts-ignore
            currentPage={page}
            isLoading={isLoading}
            customFilter={
              <div className="w-50">
                <Label>Compare period</Label>
                {/* <DatePicker
                  selected={queryObject?.period ? new Date(queryObject?.period) : undefined}
                  onChange={(date: Date) => handleChangeDatepicker(date)}
                  className="form-control"
                  showTimeSelect={false}
                  calendarClassName="react-datepicker"
                  dateFormat="yyyy-MM-dd"
                  placeholderText={"Choose a period"}
                  isClearable
                /> */}
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  className="form-control"
                  calendarClassName="react-datepicker"
                  dateFormat="dd-MM-yyyy"
                  maxDate={new Date()}
                  shouldCloseOnSelect={startDate && !endDate}
                  isClearable={true}
                  placeholderText={t("Pick a date range to compare period.")}
                />
                {queryObject?.period_from && queryObject?.period_to ? (
                  <span className="text-muted text-nowrap">
                    <div>Stats - {queryObject?.period_from !== queryObject?.period_to 
                        ? `SELECTED PERIOD`
                        : `SELECTED DATE`}
                    </div>
                    <div>
                      {/* Gains - {queryObject?.period_from === queryObject?.period_to ? 'DAILY' : 'PERIOD'} */}
                      Gains - {queryObject?.period_from !== queryObject?.period_to 
                        ? `compares ${moment(queryObject?.period_from)?.format("DD-MM-YYYY")} with ${moment(queryObject?.period_to)?.format("DD-MM-YYYY")}`
                        : `compares selected date with the day before ${moment(queryObject?.period_from)?.subtract('1', 'days')?.format("DD-MM-YYYY")}`}
                    </div>
                  </span>
                ) : (
                  <span className="text-muted text-nowrap">
                    <div>Stats - TOTAL</div>
                    <div>Gains - {`Compares today's date with yesterday's (${moment(new Date())?.subtract('1', 'days')?.format("DD-MM-YYYY")}).`}</div>
                  </span>
                )}
              </div>
            }
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state: any) => {
  const { dashbord_id, user } = state.Account
  const { feedAnalytics, totalItems, page, perPage, isLoading } = state.FeedAnalytics
  return { dashbord_id, user, feedAnalytics, totalItems, page, perPage, isLoading }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    // onDeleteFeeder: (id: any) => dispatch(deleteFeeder(id))
  }
}

export default withRouter(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Analytics))
)
